import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useNtcSensorsState } from 'z3k-settings/climatic/ntc_sensors/lib/useNtcSensorsState';
import { NtcCard } from 'z3k-settings/climatic/ntc_sensors/ui/ntc-card';
export function NtcList() {
    const { sensors } = useNtcSensorsState();
    return (_jsx(_Fragment, { children: sensors.map((sensor) => {
            return _jsx(NtcCard, { sensor_settings: sensor }, sensor.id);
        }) }));
}
